import { FieldType } from '3map-models';

export type QuestionsGroup = { groupName: string; questions: FieldType[] };
